/* import __COLOCATED_TEMPLATE__ from './fin-involvement-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();